import React, { StrictMode } from "react";
import { Routes, Route } from "react-router-dom";

// config components
import NotFound from "../pages/NotFound";
import KeycloakCallback from "../pages/KeycloakCallback";
import ProtectedRoute from "./ProtectedRoute";
import AdminRoute from "./AdminRoute";
import PublicRoute from "./PublicRoute";

// public components
import Landing from "../pages/Landing";
import Signup from "../pages/Signup";
import About from "../pages/About";
import HowItWorks from "../pages/HowItWorks";
import PricingPlans from "../pages/PricingPlans";
import Blog from "../pages/Blog";
import Contact from "../pages/Contact";
import Home from "../pages/Home";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";
import Login from "../pages/Login";
import Base from "../pages/Landing/components/Base";
import VerifyEmail from "../pages/Signup/components/VerifyEmail";
import VerifyCode from "../pages/Signup/components/VerifyCode";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ForgotPassword/components/ResetPassword";
import AuthActionHandler from "../pages/AuthActionHandler";
import OrganizationSetup from "../pages/OrganizationSetup";
import OrganizationAccept from "../pages/OrganizationAccept";
import CardDetails from "../pages/CardDetails";
import UpgradeToIndividual from "../pages/UpgradeToIndividual";

// user components
import Dashboard from "../pages/Dashboard";
import Documents from "../pages/Documents";
import Profile from "../pages/Profile";
import View from "../pages/DocumentView";
import Settings from "../pages/Settings";
import OrganizationView from "../pages/OrganizationView";
import OrganizationSettings from "../pages/OrganizationSettings";

// admin componenents
import Organizations from "../pages/Admin/Organizations";
import AdminDashboard from "../pages/Admin/AdminDashboard";

const AppRoutes: React.FC = () => {
  return (
    <StrictMode>
      <Routes>
        {/* public routes */}
        <Route path="/" element={<Base />}>
          <Route element={<PublicRoute />}>
            <Route index element={<Landing />} />
          </Route>
          <Route path="about" element={<About />} />
          <Route path="blog" element={<Blog />} />
          <Route path="howItWorks" element={<HowItWorks />} />
          <Route path="contact" element={<Contact />} />
          <Route path="pricingPlans" element={<PricingPlans />} />
          <Route path="login" element={<Login />} />
          <Route path="forgotPassword" element={<ForgotPassword />} />
          <Route path="signup" element={<Signup />} />
          <Route path="verify-email" element={<VerifyEmail />} />
          <Route path="verify-code" element={<VerifyCode />} />
          <Route path="reset-password" element={<ResetPassword />} />
        </Route>

        {/* public routes with auth check */}
        <Route path="/legal/terms-of-service" element={<TermsOfService />} />
        <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/legal/cookie-policy" element={<CookiePolicy />} />

        {/* auth */}
        <Route path="/auth/keycloak" element={<KeycloakCallback />} />
        <Route path="/auth/action" element={<AuthActionHandler />} />

        {/* organization setup */}
        <Route path="/organization/setup" element={<OrganizationSetup />} />
        <Route path="/organization/accept" element={<OrganizationAccept />} />

        {/* user routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<Home />}>
            <Route path="documents" element={<Documents />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route
              path="organization/:organizationId"
              element={<OrganizationView />}
            />
            <Route
              path="organization/:organizationId/settings"
              element={<OrganizationSettings />}
            />
          </Route>
        </Route>

        {/* admin routes */}
        <Route element={<AdminRoute />}>
          <Route path="/home" element={<Home />}>
            <Route path="admin/dashboard" element={<AdminDashboard />} />
            <Route path="admin/organizations" element={<Organizations />} />
          </Route>
        </Route>

        {/* user routes outside home base */}
        <Route element={<ProtectedRoute />}>
          <Route path="view/:id" element={<View />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/card-details" element={<CardDetails />} />
          <Route path="/upgrade" element={<UpgradeToIndividual />} />
        </Route>

        {/* 404*/}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </StrictMode>
  );
};

export default AppRoutes;
